export default __webpack_public_path__ + "3edcbc9a7bfb06872a4943278d1b578a.svg";